<template>
	<div class="page_home_download col-lg-8 mb-8">
		<!-- title -->
		<v-chip class="font-size:3rem;" text-color="white" color="primary">重要叮嚀事項</v-chip>
		<br><br>
		<NoteItem/>
	</div>
</template>

<script>
import NoteItem from './noteItem.vue';
export default {
	components: {
		NoteItem
	}
}
</script>